import {getAbsoluteUrl} from "../../utils/urlUtill";
import {IDeferred, IHttpPromise, IHttpService} from "angular";
import {OpportunityLog, OpportunityWithActions} from "../../opportunities/model/Opportunity";
import {OpportunityFilterUi} from "../../opportunities_filter/model/OpportunityFilterUi";

export class CalculationsLogService {

    static instance = ['$http', CalculationsLogService];
    private $http: IHttpService;

    constructor($http) {
        this.$http = $http;
    }

    getAllLogsPage = (pageSize: number, filter: OpportunityFilterUi, canceler: IDeferred<any>, nextCursor?: number, beforeCursor?: number): IHttpPromise<OpportunityLog[]> => {
        filter.groupByCalculator = false;
        filter.groupByCustomer = false;

        return this.$http({
            method: 'POST',
            data: filter,
            url: getAbsoluteUrl('api/calculations/execution/log'),
            params: {
                pageSize: pageSize,
                next_cursor: nextCursor,
                before_cursor: beforeCursor
            },
            timeout: canceler.promise
        });
    };

    getOpportunityDetails = (id: number): IHttpPromise<OpportunityWithActions> =>
        this.$http({
            method: 'GET',
            url: getAbsoluteUrl(`api/opportunity/execution/${id}`),
        })

    getCalculationsDetails = (id: number): IHttpPromise<OpportunityWithActions> =>
        this.$http({
            method: 'GET',
            url: getAbsoluteUrl(`api/calculations/execution/${id}`),
        })
}